import script from "./InitiatorHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InitiatorHomePage.vue?vue&type=script&setup=true&lang=js"

import "./InitiatorHomePage.vue?vue&type=style&index=0&id=3fa7c261&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa7c261"]])

export default __exports__